module.exports = __webpack_public_path__ + "img/125.1.0420e98a.jpg";